<template>
  <div class="box">
    <div class="header">
      <van-nav-bar :left-arrow="false" left-text="取消" @click-left="$router.go(-1)" />
    </div>
    <div class="main">
      <div class="title">
        <span>鞍山市中医院</span>申请使用
      </div>
      <div class="text">人脸识别验证你的身份信息，请确认为李成成本人操作</div>
      <div class="checkbox">
        <van-checkbox v-model="checked"></van-checkbox>
        <div>你同意服务提供者及腾讯使用并传送相关数据用于身份核验。查看协议详情</div>
      </div>
    </div>
    <div class="footer">
      <van-button type="primary" size="small" @click="goList">下一步</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'certification',
  data() {
    return {
      checked: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {},
    goList() {
      this.$router.push('reportList')
    }
  }
}
</script>
<style scoped>
.header /deep/ .van-nav-bar__text {
  color: rgb(102, 102, 102);
}
.main {
  padding: 0px 20px;
}
.title {
  text-align: center;
  padding-top: 50px;
}
.title span {
  font-weight: 600;
  font-size: 17px;
  padding-right: 5px;
}
.text {
  font-weight: 600;
  padding-top: 30px;
  font-size: 25px;
}
.checkbox {
  font-size: 14px;
  display: flex;
  padding: 40px 0px;
}
.checkbox .van-checkbox {
  width: 30px;
  align-items: baseline;
  padding-top: 4px;
}
.checkbox /deep/ .van-checkbox__icon {
  font-size: 14px;
}

.footer {
  width: 100vw;
  display: flex;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
